
export default {
  name: "TutorialGuideSection",
  props: {
    data: {
        type: Object,
        default: () => ({})
    }
  }
}
